import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'cell-source',
  templateUrl: './cell-source.component.html',
  styleUrls: ['./cell-source.component.scss'],
})
export class CellSourceComponent implements ICellRendererAngularComp {
  refresh;
  source: string;
  private params: any;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.source = this.params?.resourceId ? 'manual.svg' : 'automatic.png';
  }
}
